import { API_KEY, API_SERVER } from "./config";
export function makeApiUrl(path, extraQueryParams) {
    if (extraQueryParams === void 0) { extraQueryParams = ""; }
    return "".concat(API_SERVER).concat(path, "?api_key=").concat(API_KEY, "&origin=").concat(window.location.origin, "&").concat(extraQueryParams);
}
export function makeUrl(path, extraQueryParams) {
    if (extraQueryParams === void 0) { extraQueryParams = ""; }
    return "".concat(API_SERVER).concat(path);
}
